import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { Common } from '@services/common/model';
import { FooterConfig, HeaderConfig } from '@shared/models/page';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonService extends ApiServiceBase<Common> {
  private readonly common$: ReplaySubject<Common>;
  private readonly nav$: ReplaySubject<HeaderConfig>;
  private readonly footer$: ReplaySubject<FooterConfig>;

  constructor() {
    super('common');
    this.common$ = new ReplaySubject<Common>(1);
    this.nav$ = new ReplaySubject<HeaderConfig>(1);
    this.footer$ = new ReplaySubject<FooterConfig>(1);
  }

  public getCommon$(): ReplaySubject<Common> {
    return this.common$;
  }

  public setCommon(common: Common): void {
    this.common$.next(common);
  }

  public getNav$(): ReplaySubject<HeaderConfig> {
    return this.nav$;
  }

  public setNav(menu: HeaderConfig): void {
    this.nav$.next(menu);
  }

  public getFooter$(): ReplaySubject<FooterConfig> {
    return this.footer$;
  }

  public setFooter(menu: FooterConfig): void {
    this.footer$.next(menu);
  }
}
